import { COMPONENT_VALUE_TYPES as types } from 'shared/constants';
import type { PropsSchemaList } from 'shared/types/PropsSchema';

export interface Props {
  editor?: object;
  stores: {
    storeName?: string;
    address?: string;
    hours?: string;
    storeImage?: string;
    info?: {
      title?: string;
      name?: string;
      email?: string;
      phone?: string;
    }[],
    direction?: string;
  }[]
}

const propsSchema: PropsSchemaList = [
  {
    key: 'stores',
    label: 'Stores',
    type: types.ARRAY,
    children: [
      {
        key: 'storeName',
        label: 'Store Name',
        type: types.TEXT,
      },
      {
        key: 'address',
        label: 'Address',
        type: types.TEXT,
      },
      {
        key: 'hours',
        label: 'Hours',
        type: types.TEXT,
      },
      {
        key: 'storeImage',
        label: 'storeImage',
        type: types.S3_ASSET_URL,
      },
      {
        key: 'info',
        label: 'Info',
        type: types.ARRAY,
        children: [
          {
            key: 'title',
            label: 'Title',
            type: types.TEXT,
          },
          {
            key: 'name',
            label: 'Name',
            type: types.TEXT,
          },
          {
            key: 'email',
            label: 'Email',
            type: types.TEXT,
          },
          {
            key: 'phone',
            label: 'Phone',
            type: types.TEXT,
          }
        ]
      },
      {
        key: 'direction',
        label: 'Direction',
        type: types.TEXT,
      },
    ]
  }
];

const defaultProps: Props = {
  stores: [
    {
      storeName: 'FF FLAGSHIP STORE',
      address: '464 N. Beverly Drive Beverly Hills, CA',
      hours: 'Open: 10:00-17:00',
      info: [
        {
          title: 'Press Info',
          name: 'FF Company',
          email: 'Press@ff.com',
          phone: '310-956-6488',
        },
        {
          title: 'Press Info',
          name: '--',
          email: 'sales@ff.com',
          phone: '',
        }
      ],
      direction: 'https://goo.gl/maps/n9K4Jfm5yAHXzpJL8'
    },
    {
      storeName: 'FARADAY FUTURE HEADQUARTER',
      address: '18455 S Figueroa St. Los Angeles, CA 90248',
      hours: 'Open: 10:00-17:00',
      info: [
        {
          title: 'Press Info',
          name: 'John Schilling',
          email: 'Press@ff.com',
          phone: '310-956-6488',
        },
        {
          title: 'Press Info',
          name: 'Samantha',
          email: 'sales@ff.com',
          phone: '',
        }
      ],
      direction: 'https://goo.gl/maps/n9K4Jfm5yAHXzpJL8'
    }
  ]
};

export default {
  title: 'Store Location',
  id: 'StoreLocation',
  propsSchema,
  defaultProps,
}
